module.exports = __webpack_public_path__ + "static/media/responsibleIcon.29949ae5.svg";